import { FC } from 'react';
import Icon from '../icon';
import { ConnectorType, ConnectorMap } from '@/lib/models/connector';
import { Stack } from '@mui/material';
import { createUseStyles } from 'react-jss';

interface Props {
  connectorType: ConnectorType;
  size?: 'small' | 'large';
  className?: string;
}

const Sizes = {
  small: { width: 30, height: 25 },
  large: { width: 60, height: 50 },
};

const useStyles = createUseStyles<string, { width: number }>({
  connectorIcon: {
    maxWidth: ({ width }) => width,
  },
});

const ConnectorIcon: FC<Props> = ({ connectorType, size = 'small', className = '' }) => {
  const { iconSVG: IconEl, icon } = ConnectorMap.get(connectorType) || {};
  const { width, height } = Sizes[size];
  const hasIcon = !!IconEl;
  const classes = useStyles({ width });

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      maxWidth={width}
      height={height}
      className={className}
    >
      {hasIcon ? (
        <img src={IconEl} alt={connectorType} height={height} className={classes.connectorIcon} />
      ) : (
        <Icon name={icon || 'plug'} size="x-large" />
      )}
    </Stack>
  );
};

export default ConnectorIcon;
